import { useEffect } from 'react';
import useIsConsentGranted from '@alltrails/layout/hooks/UseIsConsentGranted';
import { useAppDispatch, useAppSelector } from '@/utils/redux';
import { setSprigEvent } from '@/utils/slices/customRouteSlice';

const useSprigEvent = () => {
  const dispatch = useAppDispatch();
  const sprigEvent = useAppSelector(state => state.exploreCustomRoute.sprigEvent);
  const isConsentGranted = useIsConsentGranted();

  useEffect(() => {
    // Sprig handles this check for us but the Sprig script we need to send events with is not loaded until the consent is granted
    if (!isConsentGranted) {
      return;
    }

    if (sprigEvent) {
      window.Sprig?.('identifyAndTrack', sprigEvent);
      dispatch(setSprigEvent(undefined));
    }
  }, [sprigEvent, dispatch, isConsentGranted]);
};

export default useSprigEvent;
